import * as React from "react";

import { RecipesContext } from "..";

export function useData() {
  const { data } = React.useContext(RecipesContext);

  return data;
}
